<template lang="pug">
  .c-highlights
    .c-highlights--loaded
      TourTeaser(v-if='listFull' :tourLists='tourList' :dateFormat='dateFormat' :timeFormat='timeFormat')
</template>

<script>
import TourTeaser from '@/components/TourTeaser.vue'
import axios from 'axios'

export default {
  name: 'Tour',
  props: ['tourData'],
  components: {
    TourTeaser
  },
  data() {
    return {
      tourList: [],
      listFull: false,
      dateFormat: this.getDateFormat(),
      timeFormat: this.getTimeFormat()
    }
  },
  created() {
    let vm = this
    let pageType = 'undefined'
    let pageId = 'undefined'
    if (window.dataLayer.length > 0) {
      // fill up data for proper attribution
      if (window.dataLayer[0].hasOwnProperty('pageType')) {
        pageType = window.dataLayer[0].pageType
      }
      if (window.dataLayer[0].hasOwnProperty('pagePath')) {
        // for black pearl pages
        pageId = window.dataLayer[0].pagePath
      }
      if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
        pageId = window.dataLayer[0].pagePostId
      }
    }
    if (window.gtm_tracking !== undefined && window.gtm_tracking !== null) {
      if (window.gtm_tracking.hasOwnProperty('pageType')) {
        pageType = window.gtm_tracking.pageType
      }
      if (window.gtm_tracking.hasOwnProperty('pagePath')) {
        // for black pearl pages
        pageId = window.gtm_tracking.pagePath
      }
      if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
        pageId = window.gtm_tracking.pagePostId
      }
    }
    this.tourData.product = pageType
    this.tourData.pageid = pageId
    axios
      .get(
        'https://e9wn39oj5g.execute-api.eu-central-1.amazonaws.com/prod/v1/tours/' +
          this.tourData.market +
          '?searchTerm=' +
          this.tourData.searchTerm +
          '&from=' +
          this.tourData.startDate +
          '&to=' +
          this.tourData.endDate +
          '&limit=' +
          this.tourData.limit
      )
      .then(function(response) {
        if (response.data.totalCount > 0) {
          vm.tourList.push(response.data)
          vm.listFull = true
        }
      })
  },
  methods: {
    getDateFormat() {
      if (this.$store.getters.getLocale === 'en-US') {
        return 'MM/DD/YYYY'
      }
      return 'DD.MM.YYYY'
    },
    getTimeFormat() {
      let timeFormat = 'HH:mm'
      return timeFormat
    }
  }
}
</script>
